import { useFormContext } from 'react-hook-form';

import { SolcellerFormData } from '../types';

export const useSolcelleFormContext = () => {
  return useFormContext<SolcellerFormData>();
};

type Result = {
  field: string;
  message: string | undefined;
  type: string | undefined;
  fieldId: string | undefined;
}[];

export const findErrorsRecursively = (obj: Record<string, any>, result: Result = []) => {
  for (const key in obj) {
    const value = obj?.[key];

    if (typeof value !== 'object') {
      return result;
    }

    if (typeof value === 'object' && (value?.type || value?.message)) {
      result.push({ field: key, message: value?.message, type: value?.type, fieldId: value?.ref.id });
    } else {
      // Continue recursively for nested objects
      findErrorsRecursively(value, result);
    }
  }

  return result;
};
